// @generated by protoc-gen-es v1.10.0
// @generated from file ibc/core/client/v1/tx.proto (package ibc.core.client.v1, syntax proto3)
/* eslint-disable */
// @ts-nocheck

import { Any, proto3 } from "@bufbuild/protobuf";
import { Plan } from "@buf/cosmos_cosmos-sdk.bufbuild_es/cosmos/upgrade/v1beta1/upgrade_pb.js";
import { Params } from "./client_pb.js";

/**
 * MsgCreateClient defines a message to create an IBC client
 *
 * @generated from message ibc.core.client.v1.MsgCreateClient
 */
export const MsgCreateClient = /*@__PURE__*/ proto3.makeMessageType(
  "ibc.core.client.v1.MsgCreateClient",
  () => [
    { no: 1, name: "client_state", kind: "message", T: Any },
    { no: 2, name: "consensus_state", kind: "message", T: Any },
    { no: 3, name: "signer", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * MsgCreateClientResponse defines the Msg/CreateClient response type.
 *
 * @generated from message ibc.core.client.v1.MsgCreateClientResponse
 */
export const MsgCreateClientResponse = /*@__PURE__*/ proto3.makeMessageType(
  "ibc.core.client.v1.MsgCreateClientResponse",
  [],
);

/**
 * MsgUpdateClient defines an sdk.Msg to update a IBC client state using
 * the given client message.
 *
 * @generated from message ibc.core.client.v1.MsgUpdateClient
 */
export const MsgUpdateClient = /*@__PURE__*/ proto3.makeMessageType(
  "ibc.core.client.v1.MsgUpdateClient",
  () => [
    { no: 1, name: "client_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "client_message", kind: "message", T: Any },
    { no: 3, name: "signer", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * MsgUpdateClientResponse defines the Msg/UpdateClient response type.
 *
 * @generated from message ibc.core.client.v1.MsgUpdateClientResponse
 */
export const MsgUpdateClientResponse = /*@__PURE__*/ proto3.makeMessageType(
  "ibc.core.client.v1.MsgUpdateClientResponse",
  [],
);

/**
 * MsgUpgradeClient defines an sdk.Msg to upgrade an IBC client to a new client
 * state
 *
 * @generated from message ibc.core.client.v1.MsgUpgradeClient
 */
export const MsgUpgradeClient = /*@__PURE__*/ proto3.makeMessageType(
  "ibc.core.client.v1.MsgUpgradeClient",
  () => [
    { no: 1, name: "client_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "client_state", kind: "message", T: Any },
    { no: 3, name: "consensus_state", kind: "message", T: Any },
    { no: 4, name: "proof_upgrade_client", kind: "scalar", T: 12 /* ScalarType.BYTES */ },
    { no: 5, name: "proof_upgrade_consensus_state", kind: "scalar", T: 12 /* ScalarType.BYTES */ },
    { no: 6, name: "signer", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * MsgUpgradeClientResponse defines the Msg/UpgradeClient response type.
 *
 * @generated from message ibc.core.client.v1.MsgUpgradeClientResponse
 */
export const MsgUpgradeClientResponse = /*@__PURE__*/ proto3.makeMessageType(
  "ibc.core.client.v1.MsgUpgradeClientResponse",
  [],
);

/**
 * MsgSubmitMisbehaviour defines an sdk.Msg type that submits Evidence for
 * light client misbehaviour.
 * This message has been deprecated. Use MsgUpdateClient instead.
 *
 * @generated from message ibc.core.client.v1.MsgSubmitMisbehaviour
 * @deprecated
 */
export const MsgSubmitMisbehaviour = /*@__PURE__*/ proto3.makeMessageType(
  "ibc.core.client.v1.MsgSubmitMisbehaviour",
  () => [
    { no: 1, name: "client_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "misbehaviour", kind: "message", T: Any },
    { no: 3, name: "signer", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * MsgSubmitMisbehaviourResponse defines the Msg/SubmitMisbehaviour response
 * type.
 *
 * @generated from message ibc.core.client.v1.MsgSubmitMisbehaviourResponse
 */
export const MsgSubmitMisbehaviourResponse = /*@__PURE__*/ proto3.makeMessageType(
  "ibc.core.client.v1.MsgSubmitMisbehaviourResponse",
  [],
);

/**
 * MsgRecoverClient defines the message used to recover a frozen or expired client.
 *
 * @generated from message ibc.core.client.v1.MsgRecoverClient
 */
export const MsgRecoverClient = /*@__PURE__*/ proto3.makeMessageType(
  "ibc.core.client.v1.MsgRecoverClient",
  () => [
    { no: 1, name: "subject_client_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "substitute_client_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "signer", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * MsgRecoverClientResponse defines the Msg/RecoverClient response type.
 *
 * @generated from message ibc.core.client.v1.MsgRecoverClientResponse
 */
export const MsgRecoverClientResponse = /*@__PURE__*/ proto3.makeMessageType(
  "ibc.core.client.v1.MsgRecoverClientResponse",
  [],
);

/**
 * MsgIBCSoftwareUpgrade defines the message used to schedule an upgrade of an IBC client using a v1 governance proposal
 *
 * @generated from message ibc.core.client.v1.MsgIBCSoftwareUpgrade
 */
export const MsgIBCSoftwareUpgrade = /*@__PURE__*/ proto3.makeMessageType(
  "ibc.core.client.v1.MsgIBCSoftwareUpgrade",
  () => [
    { no: 1, name: "plan", kind: "message", T: Plan },
    { no: 2, name: "upgraded_client_state", kind: "message", T: Any },
    { no: 3, name: "signer", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * MsgIBCSoftwareUpgradeResponse defines the Msg/IBCSoftwareUpgrade response type.
 *
 * @generated from message ibc.core.client.v1.MsgIBCSoftwareUpgradeResponse
 */
export const MsgIBCSoftwareUpgradeResponse = /*@__PURE__*/ proto3.makeMessageType(
  "ibc.core.client.v1.MsgIBCSoftwareUpgradeResponse",
  [],
);

/**
 * MsgUpdateParams defines the sdk.Msg type to update the client parameters.
 *
 * @generated from message ibc.core.client.v1.MsgUpdateParams
 */
export const MsgUpdateParams = /*@__PURE__*/ proto3.makeMessageType(
  "ibc.core.client.v1.MsgUpdateParams",
  () => [
    { no: 1, name: "signer", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "params", kind: "message", T: Params },
  ],
);

/**
 * MsgUpdateParamsResponse defines the MsgUpdateParams response type.
 *
 * @generated from message ibc.core.client.v1.MsgUpdateParamsResponse
 */
export const MsgUpdateParamsResponse = /*@__PURE__*/ proto3.makeMessageType(
  "ibc.core.client.v1.MsgUpdateParamsResponse",
  [],
);

